import { Injectable } from '@angular/core';
import { apiUrl } from '../config/api';
import { PlayerRegistryEntry, PlayerRegistryImportResult } from '../models/team';

@Injectable({ providedIn: 'root' })
export class PlayerRegistryService {
  private readonly apiUrl = apiUrl('/api/player-registry');

  list(): Promise<PlayerRegistryEntry[]> {
    return this.request<PlayerRegistryEntry[]>(this.apiUrl);
  }

  get(id: number): Promise<PlayerRegistryEntry> {
    return this.request<PlayerRegistryEntry>(`${this.apiUrl}/${id}`);
  }

  create(player: Partial<PlayerRegistryEntry>): Promise<PlayerRegistryEntry> {
    return this.request<PlayerRegistryEntry>(this.apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(player)
    });
  }

  update(id: number, player: Partial<PlayerRegistryEntry>): Promise<PlayerRegistryEntry> {
    return this.request<PlayerRegistryEntry>(`${this.apiUrl}/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(player)
    });
  }

  async delete(id: number): Promise<void> {
    await this.request<{ success: boolean }>(`${this.apiUrl}/${id}`, { method: 'DELETE' });
  }

  async deleteAll(): Promise<void> {
    await this.request<{ success: boolean }>(this.apiUrl, { method: 'DELETE' });
  }

  importFile(file: File): Promise<PlayerRegistryImportResult> {
    const body = new FormData();
    body.append('file', file);
    return this.request<PlayerRegistryImportResult>(`${this.apiUrl}/import`, {
      method: 'POST',
      body
    });
  }

  private async request<T>(url: string, init?: RequestInit): Promise<T> {
    const response = await fetch(url, { cache: 'no-store', ...init });
    const data = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(data?.error ?? 'Errore API');
    }

    return data as T;
  }
}
